import EventEmitter from 'eventemitter3'

const emitter = new EventEmitter()
export default emitter
